module.exports = __webpack_public_path__ + "static/media/top-filter-dark-icon.0cdb49ed.svg";